export enum Role {
    SuperAdmin = "Super Admin",
    Admin = "Admin",
    Agent = "Agent",
    Customer = "Customer",
    Manager = "Manager",
  }

export type RoleType = keyof typeof Role; 